import React from "react";
import clsx from "clsx";
import { Text } from "@merge-api/merge-javascript-shared";

import OpenAILogo from "../../../../../assets/svg/customer-logos/openai.svg";
import FactoryLogo from "../../../../../assets/svg/customer-logos/factory.svg";
import DropboxLogo from "../../../../../assets/svg/customer-logos/dropbox.svg";
import PerplexityLogo from "../../../../../assets/svg/customer-logos/perplexity.svg";
import RampLogo from "../../../../../assets/svg/customer-logos/ramp.svg";
import DrataLogo from "../../../../../assets/svg/customer-logos/drata.svg";
import BillLogo from "../../../../../assets/svg/customer-logos/bill.svg";
import ThomsonReutersLogo from "../../../../../assets/svg/customer-logos/thomson-reuters.svg";
import FreshworksLogo from "../../../../../assets/svg/customer-logos/freshworks.svg";
import PayscaleLogo from "../../../../../assets/svg/customer-logos/payscale.svg";
import BambooHRLogo from "../../../../../assets/svg/customer-logos/bamboohr.svg";
import KornFerryLogo from "../../../../../assets/svg/customer-logos/korn-ferry.svg";

type Logo = { src: string; name: string; height?: string; padding?: string };

const LOGO_PAIRS: Logo[][] = [
  [
    { src: OpenAILogo, name: "OpenAI" },
    { src: BillLogo, name: "Bill" },
  ],
  [
    { src: FactoryLogo, name: "Factory", height: "h-5", padding: "py-2.5" },
    { src: ThomsonReutersLogo, name: "Thomson Reuters", height: "h-7", padding: "py-1.5" },
  ],
  [
    { src: DropboxLogo, name: "Dropbox" },
    { src: FreshworksLogo, name: "Freshworks" },
  ],
  [
    { src: PerplexityLogo, name: "Perplexity" },
    { src: PayscaleLogo, name: "Payscale" },
  ],
  [
    { src: RampLogo, name: "Ramp" },
    { src: BambooHRLogo, name: "BambooHR" },
  ],
  [
    { src: DrataLogo, name: "Drata", height: "h-5", padding: "py-2.5" },
    { src: KornFerryLogo, name: "Korn Ferry" },
  ],
];

const TrustedByPanel = () => (
  <div className="w-full flex flex-col gap-3">
    <div className="flex justify-center">
      <Text variant="md">Trusted to power integrations at</Text>
    </div>
    <div className="hidden md:flex justify-between items-start">
      {LOGO_PAIRS.map(([top, bottom]) => (
        <div key={top.name} className="flex flex-col items-center gap-3">
          <div className={top.padding ?? "py-2"}>
            <img
              src={top.src}
              alt={top.name}
              className={clsx("block w-auto object-contain", top.height ?? "h-6")}
            />
          </div>
          <div className={bottom.padding ?? "py-2"}>
            <img
              src={bottom.src}
              alt={bottom.name}
              className={clsx("block w-auto object-contain", bottom.height ?? "h-6")}
            />
          </div>
        </div>
      ))}
    </div>
    <div className="md:hidden flex flex-col items-center gap-6">
      {LOGO_PAIRS.flat().map(({ src, name }) => (
        <div key={name} className="h-8 w-[78px] flex items-center justify-center">
          <img src={src} alt={name} className="block max-h-full max-w-full object-contain" />
        </div>
      ))}
    </div>
  </div>
);

export default TrustedByPanel;
